import React from 'react';
import { Breadcrumbs, Link, Paper, Typography } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

interface ClientDetailsV2BreadcrumbsProps {
  clientsBackPath: string;
  clientDisplayName: string;
}

export const ClientDetailsV2Breadcrumbs: React.FC<ClientDetailsV2BreadcrumbsProps> = ({
  clientsBackPath,
  clientDisplayName,
}) => {
  return (
    <Paper
      elevation={0}
      sx={{
        borderRadius: '16px',
        border: '1px solid #dbe6eb',
        bgcolor: '#fafcfe',
        px: 3,
        py: 1.5,
        width: '100%',
        flexShrink: 0,
      }}
    >
      <Breadcrumbs separator="/" aria-label="breadcrumb">
        <Link
          component={RouterLink}
          underline="hover"
          color="inherit"
          to={clientsBackPath}
          sx={{ fontFamily: 'Inter, sans-serif', fontSize: '0.8125rem' }}
        >
          My Clients
        </Link>
        <Typography sx={{ fontFamily: 'Inter, sans-serif', fontSize: '0.8125rem', color: '#0f172a' }}>
          {clientDisplayName}
        </Typography>
      </Breadcrumbs>
    </Paper>
  );
};
